<template>
	<div id="container">
		<div id="subtitleSettingContainer">
            <header class="mdc-top-app-bar">
                <div class="mdc-top-app-bar__row">
                    <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                        <a class="material-icons mdc-top-app-bar__navigation-icon" @click="onClose()">close</a>
                    </section>
                    
                    <section class="mdc-top-app-bar__section title">
                        <div class="mdc-top-app-bar__title">
                            {{$t('1109')}}
                            <!-- Subtitle Setting -->
                        </div>                
                    </section>

                    <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                        <a class="material-icons mdc-top-app-bar__navigation-icon"></a>
                    </section>
                </div>
                
            </header>
			<section id="subtitleSettingContents">
				<div id="subtitles">
                    <!-- {{subtitles}} -->
					<div class="subtitle-list">
                        <div>
                            <ul>
                                <li v-if="subtitles.length > 0" style="color: #ffffff;font-size: 22px">
                                    <div class="typography--s4">
                                        Subtitle
                                        <!-- {{$t('1092')}} -->
                                        <!-- Main subtitles -->

                                    </div>
                                </li>
                                <li @click="setFirstSubtitle('')" :class="{'active': firstSubtitle === ''}">
                                    <div>
                                        {{$t('1110')}}
                                        <!-- Not used -->
                                    </div>
                                </li>
                                <li v-for="(subtitle, index) in subtitles" :key="index"  @click="setFirstSubtitle(subtitle.language.value)"  :class="{'active': firstSubtitle === subtitle.language.value }">
                                    <div>{{subtitle.language.text}}</div>
                                </li>
                                
                            </ul>
                        </div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>
<script>


export default {
    props: ['subtitles', 'setedFirstSubtitle'],
    data() {
        return {
            firstSubtitle: '',
        }
    },
    
    mounted() {
        this.firstSubtitle = this.setedFirstSubtitle
    },
    
    methods: {
        onClose: function () {
            this.$emit('subtitle-settings-toggle');
        },
        
        setFirstSubtitle(language) {
            if (this.firstSubtitle === language) {
                this.firstSubtitle = ''
            }else {
                this.firstSubtitle = language
            }
            this.$emit('setSubtitles',this.$data)
        },

    }
}
</script>